define(['edge/platform/base/BaseCtrl'], (BaseCtrl)=> {
    const fn = ($scope, $stateParams)=> {
        const ctrl = Object.create(BaseCtrl);

        ctrl.init = ()=> {
            $scope.errorMsg = $stateParams.errorMsg;
            $scope.quoteID = $stateParams.quoteID;
        };

        return ctrl.create($scope);
    };
    fn.$inject = ['$scope', '$stateParams'];

    return fn;
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/common/controllers/ContactUsCtrl.js